package org.example.project.enginevertrieb

import androidx.compose.runtime.*
import kotlinx.browser.window
import org.example.project.dashboard.ScreenManager
import org.example.project.dashboard.TrackedScreenHost
import org.example.project.engineslot.SlotActionBarRow
import org.example.project.engineslot.SlotStyles
import org.example.project.service.RollenService
import org.example.project.settings.LumaticaButton
import org.example.project.settings.LumaticaButtonVariant
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*

@Composable
internal fun VertriebBereichWrapper(screenKey: String, node: String) {
    val screens = ScreenManager.childScreensForKey(screenKey, node)
        .filter { RollenService.hasReadPermission(it.key) }
    val initialCall = remember(screenKey) {
        window.location.hash.substringAfter('?', "").split('&').firstOrNull { it.substringBefore('=') == "callProspect" }
            ?.substringAfter('=')?.let { js("decodeURIComponent")(it) as String }?.takeIf { it.isNotBlank() }
    }
    val initialContact = remember(screenKey) {
        window.location.hash.substringAfter('?', "").split('&').firstOrNull { it.substringBefore('=') == "linkedinContact" }
            ?.substringAfter('=')?.let { js("decodeURIComponent")(it) as String }?.takeIf { it.isNotBlank() }
            ?: initialCall?.let { "web-$it" }
    }
    var selectedKey by remember(screenKey) { mutableStateOf(if (initialContact != null) "LinkedInFlow" else "") }
    val activeKey = selectedKey.takeIf { key -> screens.any { it.key == key } }
        ?: screens.firstOrNull()?.key
        .orEmpty()
    val selected = screens.firstOrNull { it.key == activeKey }
    Style(SlotStyles)
    Div({ classes(SlotStyles.screenRoot) }) {
        SlotActionBarRow({}, {
            Div({ style { display(DisplayStyle.Flex); width(100.percent); minWidth(0.px); alignItems(AlignItems.Center); justifyContent(JustifyContent.Center); gap(12.px); flexWrap(FlexWrap.Wrap) } }) {
                screens.forEach { screen ->
                    LumaticaButton(screen.label, { selectedKey = screen.key },
                        variant = LumaticaButtonVariant.State, isActive = activeKey == screen.key)
                }
            }
        }, {}, fullWidthCenter = true)
        Div({ style { width(100.percent); height(1.px); backgroundColor(Color("rgba(255,255,255,0.14)")); flexShrink(0) } })
        Div({ style { flex("1"); minHeight(0.px); overflowY("auto") } }) {
            if (selected == null) Text("Keine freigegebenen Bereiche vorhanden.")
            else key(selected.key) {
                TrackedScreenHost(selected) {
                    if (selected.key == "LinkedInFlow") LinkedInLeadUebernahme(node, initialContactId = initialContact)
                    else selected.content?.invoke(selected)
                }
            }
        }
    }
}
